import { capitalisedTermForCompany } from "../../../copy/sharedCopy";
import { type ApiFileTransferItem } from "../../../models/api/admin/fileSafe";
import { formatDateToString } from "../../../utils/formatDateToString";
import StatusPill from "../../ReusableComponents/StatusPill/StatusPill";
import {
    type TableContent,
    type TableHeader,
} from "../../ReusableComponents/Table";
import UserIcon from "../../UserIcon";

type AllowedIds =
    | "from"
    | "transferDate"
    | "fileNumber"
    | "client"
    | "departments"
    | "status";

type FileSafeInboxTableContent = TableContent<ApiFileTransferItem, AllowedIds>;

export const initFileSafeInboxTableHeaders: TableHeader[] = [
    {
        title: "From",
        id: "from",
    },
    {
        title: "Transfer date",
        id: "transferDate",
    },
    {
        title: "No. of Files",
        id: "fileNumber",
    },
    {
        title: capitalisedTermForCompany,
        id: "client",
    },
    {
        title: "Departments",
        id: "departments",
    },
    {
        title: "Status",
        id: "status",
    },
];

const statusColor = (status: string | null) => {
    if (status === null || status === undefined) return "bg-S2D-neutral-70";

    if (status === "New") {
        return "bg-S2D-success-80";
    } else if (status === "Transferred") {
        return "";
    } else {
        return "bg-S2D-warning-90";
    }
};

export function initFileSafeInboxTableContents(
    transfers: ApiFileTransferItem[]
): FileSafeInboxTableContent[] {
    const tableContents = new Array<FileSafeInboxTableContent>(0);
    transfers.map((transfer) => {
        tableContents.push({
            rowId: transfer.transferId,
            rowData: transfer,
            cellData: [
                {
                    id: "from",
                    content: (
                        <div className="flex items-center gap-2">
                            {transfer.from.firstName && (
                                <UserIcon
                                    firstName={transfer.from.firstName}
                                    lastName={transfer.from.lastName}
                                    size="small"
                                />
                            )}

                            <p>
                                {`${transfer.from.firstName} ${transfer.from.lastName}`}
                            </p>
                        </div>
                    ),
                },
                {
                    id: "transferDate",
                    content: (
                        <p>
                            {transfer.transferDate
                                ? formatDateToString(
                                      new Date(transfer.transferDate),
                                      true
                                  )
                                : ""}
                        </p>
                    ),
                },
                {
                    id: "fileNumber",
                    content: <p>{transfer.fileCount}</p>,
                },
                {
                    id: "client",
                    content: <p>{transfer.client}</p>,
                },
                {
                    id: "departments",
                    content: (
                        <p>
                            {transfer.departments
                                ?.map((department) => department)
                                .join(", ")}
                        </p>
                    ),
                },
                {
                    id: "status",
                    content: (
                        <div className="pl-2">
                            <StatusPill
                                status={transfer.status}
                                bgColour={statusColor(transfer.status)}
                            />
                        </div>
                    ),
                },
            ],
        });
    });
    return tableContents;
}
